import { ListPagination } from '@workspace/data-types';

interface QueryParam {
  name: string;
  value: string | number;
}

export interface ExtraQueryParam {
  name: 'tab';
  value: string;
}

export class QueryParamsUtils {
  static buildParams(params: QueryParam[]) {
    return params.length > 0
      ? `?${params.map((param) => this.buildParam(param.name, param.value)).join('&')}`
      : '';
  }

  static buildParam(paramName: string, value: string | number) {
    return `${paramName}=${value}`;
  }

  static buildFilterParams(
    pagination?: ListPagination,
    count = false,
    extraParams: ExtraQueryParam[] = [],
  ): string {
    if (!pagination) {
      return '';
    }
    const params: QueryParam[] = [];
    if (!count) {
      if (pagination.page !== undefined && pagination.pageSize !== undefined) {
        params.push(
          { name: 'page', value: encodeURIComponent(pagination.page) },
          { name: 'pageSize', value: encodeURIComponent(pagination.pageSize) },
        );
      }
      if (pagination.orderBy) {
        params.push({
          name: 'orderBy',
          value: encodeURIComponent(pagination.orderBy),
        });
      }
      if (pagination.order) {
        params.push({
          name: 'order',
          value: encodeURIComponent(pagination.order),
        });
      }
    }
    if (pagination.search) {
      params.push({
        name: 'search',
        value: encodeURIComponent(pagination.search),
      });
    }
    if (pagination.filters) {
      Object.entries(pagination.filters).forEach(([key, val]) => {
        if (Array.isArray(val)) {
          val.forEach((v) => params.push({ name: key, value: v }));
        } else if (val) {
          params.push({ name: key, value: val });
        }
      });
    }

    return this.buildParams([...extraParams, ...params]);
  }

  static toParams(
    pagination?: ListPagination,
    count = false,
    extraParams: ExtraQueryParam[] = [],
  ): Record<string, unknown> {
    if (!pagination) {
      return {};
    }
    const params: Record<string, unknown> = {};

    if (!count) {
      if (pagination.page !== undefined) params['page'] = pagination.page;
      if (pagination.pageSize !== undefined) params['pageSize'] = pagination.pageSize;
      if (pagination.orderBy) params['orderBy'] = pagination.orderBy;
      if (pagination.order) params['order'] = pagination.order;
    }

    if (pagination.search) params['search'] = pagination.search;

    if (pagination.filters) {
      Object.entries(pagination.filters).forEach(([key, val]) => {
        if (val !== undefined && val !== null) {
          params[key] = val;
        }
      });
    }

    extraParams.forEach((p) => (params[p.name] = p.value));

    return params;
  }
}
